
BaseModel = require 'BaseModel'

###############################################

class GameModel extends BaseModel

  name: 'GameModel'
  _instance: null

  # -------------------------------------------

  getDebug: ->
    @get 'debug'

  # -------------------------------------------

  getFont: ->
    @get 'font'

  # -------------------------------------------

  getFontWithVariations: ->
    @getFont() + @get 'fontVariations'

  # -------------------------------------------

  getSecondaryFont: ->
    @get 'secondaryFont'

  # -------------------------------------------

  getBaseMultiplier: ->
    @get 'baseMultiplier'

  # -------------------------------------------

  getDefaultStake: ->
    @get 'defaultStake'

  # -------------------------------------------

  getStake: ->
    @getDefaultStake()

  # -------------------------------------------

  getCurrencyMultiplier: ->
    @getDefaultStake() / @getBaseMultiplier()

  # -------------------------------------------

  getPlayerTokenId: ->
    @get 'playerTokenId'

  # -------------------------------------------

  getDefaultCurrencyCode: ->
    @get 'defaultCurrency'

  # -------------------------------------------

  getCurrencyCode: ->
    @get 'currencyCode'

  # -------------------------------------------

  getDefaultLanguageCode: ->
    @get 'defaultLanguage'

  # -------------------------------------------

  getLanguageCode: ->
    @get 'languageCode'

  # -------------------------------------------

  getBaseLanguageCode: ->
    @getLanguageCode().substring(0,2)

  # -------------------------------------------

  getClientToken: ->
    @get 'clientToken'

  # -------------------------------------------

  getBalanceUrl: ->
    @get 'balanceUrl'

  # -------------------------------------------

  getBalanceDelay: ->
    @get 'balanceDelay'

  # -------------------------------------------

  getEndUrl: ->
    @get 'endUrl'

  # -------------------------------------------

  getNotifyUrl: ->
    @get 'notifyUrl'

  # -------------------------------------------

  getPlaceBetUrl: ->
    @get 'placeBetUrl'

  # -------------------------------------------

  getCashierUrl: ->
    @get 'cashierUrl'

  # -------------------------------------------

  getBuyMoreUrl: ->
    @get 'buyMoreUrl'

  # -------------------------------------------

  getShowBuyMorePopup: ->
    @get 'showBuyMorePopup'

  # -------------------------------------------

  getHistoryUrl: ->
    @get 'historyUrl'

  # -------------------------------------------

  shouldShowBuyMoreButton: ->
    @getShowBuyMorePopup()?

  # -------------------------------------------

  shouldShowBuyMorePopup: ->
    hm = @getHomeUrl()
    bu = @getBuyMoreUrl()
    sp = @getShowBuyMorePopup()
    return true if sp and (bu? or hm?)
    false

  # -------------------------------------------

  isOutOfTickets: ->
    bm = @isBasketMode()
    hr = @hasRoundsLeft()

    res = false
    res = true if bm and not hr
    res

  # -------------------------------------------

  isOutOfFunds: ->
    bm = @isBasketMode()
    ba = @getBalance()
    return true if not bm and ba <= 0
    false

  # -------------------------------------------

  getHomeUrl: ->
    url = @get 'homeUrl'
    return null if not url? or typeof url isnt 'string'
    return null if url is '(none)'
    url

  # -------------------------------------------

  getHelpUrl: ->

    url = @get 'helpUrl'

    return null unless url?

    s = @getStake()
    bm = @getBaseMultiplier()
    mu = s/bm

    lc = @getBaseLanguageCode()
    cc = @getCurrencyCode()

    # 888 Hack to hide RC info in help file
    rc = false #@shouldShowRealityCheck()

    return '' unless url?

    url = url + "&data=cc-" + cc + "$mu-" + mu + "$rc-" + rc + "&v=" + window.__version

    # if @apiGameCode?
    #   url = url.replace(@gameCode,'PP_HTML5_HerculesMagnus85')

    url

  # -------------------------------------------

  shouldShowRealityCheck: ->
    rct = @getRealityCheckTimeout()
    return false if not rct?
    return false if isNaN(rct)
    return false if rct <= 0
    true

  # -------------------------------------------

  getRealityCheckTimeout: ->
    @get 'realityCheckTimeout'

  # -------------------------------------------

  setRealityCheckTimeout: (v) ->
    @set 'realityCheckTimeout', v

  # -------------------------------------------

  getRealityInterval: ->
    @get 'realityInterval'

  # -------------------------------------------

  getRealityIntervalInMs: ->
    @getRealityInterval() * 60 * 1000

  # -------------------------------------------

  setRealityInterval: (v) ->

    @set 'realityInterval', v
    window.localStorage.setItem 'reality', v

  # -------------------------------------------

  setDefaultRealityInterval: ->

    r = @getRealityCheckTimeout()
    @setRealityInterval(r)
    r

    # BELOW is the old logic for the reality check

    # v = window.localStorage.getItem 'reality'
    # r = @getRealityCheckTimeout()

    # return unless r?

    # if v%r isnt 0 or v > r * 4 or v < 0
    #   @setRealityInterval(r)
    #   return

    # if v?
    #   @setRealityInterval(v)
    #   return

    # if not @RealityInterval?
    #   @setRealityInterval(@RealityCheckTimeout)

    # v

  # -------------------------------------------

  getGameCode: ->
    @get 'gameCode'

  # -------------------------------------------

  getReplayOutcome: ->
    @get 'replayOutcome'

  # -------------------------------------------

  getPaytable: ->
    @get 'paytable'

  # -------------------------------------------

  getRandomWin: ->
    p = @getPaytable()
    Math.floor(Math.random()*p.length)

  # -------------------------------------------

  getPrizeForId: (index) ->
    if index <= 0
      console.error('prizesIndex cannot be:', index )

    p = @images.prizes[index]
    p.split('|')

  # -------------------------------------------

  getPrizeImgForId: (index) ->

    if @hasMultiplier
      prizeData = @getPrizeForId(index)
      prizeNum = prizeData[0]
      return Number(prizeNum)

    return @images.prizes[index]

  # -------------------------------------------

  getPrizeAmount: (index) ->
    index = parseInt index
    offsetIndex = index - 1
    p = @getPaytable()
    a = p[offsetIndex]
    m = a * @getStake()

    if @hasMultiplier
      multi = @getPrizeForId(index)[1]
      m = m / Number(multi)

    r = Math.round(m * 100) / 100
    r

  # -------------------------------------------

  getPrizeYOffetForId: (index) ->
    return 0 if not @images.yOffset?[index]?
    @images.yOffset[index]

  # -------------------------------------------

  getSoundForPrizeId: (prizeId) ->
    return null if not @sounds?.prizes?
    @sounds.prizes[prizeId]

  # -------------------------------------------

  isMaxPrize: (index) ->
    @maxPrize is Number(index)

  # -------------------------------------------

  getMaxPrize: ->
    p = @getPaytable()
    return "" unless p?
    a = @getPrizeAmount(p.length)
    if @hasMultiplier
      m = @getPrizeForId(p.length)[1]
      a = a*m
    a

  # -------------------------------------------

  getExtraData: ->
    @get 'extraData'

  # -------------------------------------------

  getStatus: ->
    @get 'status'

  # -------------------------------------------

  getBalance: ->
    s = @getStatus()
    return null unless s?
    s.balance

  # -------------------------------------------

  setBalance: (v) ->
    s = @getStatus()
    return null unless s?
    s.balance = v

  # -------------------------------------------

  getFinancialMode: ->
    s = @getStatus()
    return null unless s?
    s.financialMode

  # -------------------------------------------

  setFinancialMode: (v) ->
    s = @getStatus()
    return null unless s?
    s.financialMode = v

  # -------------------------------------------

  isBasketMode: ->
    @getFinancialMode() is 1

  # -------------------------------------------

  getRoundsLeft: ->
    s = @getStatus()
    return null unless s?
    s.roundsLeft

  # -------------------------------------------

  setRoundsLeft: (v) ->
    s = @getStatus()
    return null unless s?
    s.roundsLeft = v

  # -------------------------------------------

  hasRoundsLeft: ->
    @getRoundsLeft() > 0

  # -------------------------------------------
  # CONFIG SHIT
  # -------------------------------------------

  isDebug: ->
    @get 'debug'

  # -------------------------------------------

  getMode: ->
    @get 'mode'

  # -------------------------------------------

  getDontShowBalance: ->
    @get 'dontShowBalance'

  # -------------------------------------------

  getDontShowStake: ->
    @get 'dontShowStake'

  # -------------------------------------------

  getShowTicketId: ->
    @get 'showTicketId'

  # -------------------------------------------

  getSound: ->
    s = @get 'sound'

    if typeof(s) is 'number'

      if s > 0
        @set 'defaultVolume', s
        @setMute(false)

      else
        @setMute(true)

    if typeof(s) is 'boolean'
      @setMute(!s)

    @getDefaultVolume()

  # -------------------------------------------

  getInitialMute: ->
    mute = true

    if not __isMobile

      m = window.localStorage.getItem 'mute'
      mute = false if not m? or m is 'false'

    @setMute mute

    mute

  # -------------------------------------------

  getMute: ->
    m = @get 'mute'
    return m if m?
    @getInitialMute()

  # -------------------------------------------

  setMute: (v) ->
    @set 'mute', v
    window.localStorage.setItem 'mute', v

  # -------------------------------------------

  getDefaultVolume: ->
    @get 'defaultVolume'

  # -------------------------------------------

  # make Singleton
  @getInstance: ->
    @_instance = new @ if not @_instance?
    @_instance

  # -------------------------------------------

module.exports = GameModel.getInstance()



// WEBPACK FOOTER //
// ./coffee/model/game-model.coffee